import { useState, useEffect } from "react";
import axios from "axios";

const API_URL = "https://inaaniserver-50c4305cc7f7.herokuapp.com/users/get_all_users";
const EDIT_URL = "https://inaaniserver-50c4305cc7f7.herokuapp.com/users/edit";

const useUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch Users
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(API_URL, {
          headers: { "Access-Control-Allow-Origin": "*" }
        });

        if (response.data.status) {
          setUsers(response.data.data);
        } else {
          throw new Error(response.data.message || "Failed to fetch users");
        }
      } catch (err) {
        setError(err.message || "An error occurred while fetching users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // Update User Status
  const updateUserStatus = async (user) => {
    try {
        if (!user || !user.id) {
            throw new Error("User ID is missing in the request.");
        }

        const response = await axios.post(EDIT_URL, { 
            id: user.id, 
            fullname: user.fullname || "", 
            password: user.password || "", 
            contact: user.contact || "", 
            email: user.email || "", 
            address: user.address || "", 
            role: user.role || "", 
            status: user.status 
        });

        if (response.data.error) {
            throw new Error(response.data.message);
        }

        setUsers(prevUsers =>
            prevUsers.map(u => (u.id === user.id ? { ...u, status: user.status } : u))
        );

        return { success: true, message: response.data.message };
    } catch (err) {
        return { success: false, message: err.message };
    }
};

  return { users, loading, error, updateUserStatus };
};

export default useUsers;
